import './input_date.css';

const InputDate = ({ label, id, name, value, onChange, required = false, error, className = '' }) => {
    return (
        <div className={`base-input-container ${className}`}>
            <label className="base-label" htmlFor={id}>{label}</label>
            <input
                type="month"
                id={id}
                name={name}
                value={value}
                onChange={onChange}
                required={required}
                className={`base-input-field ${error ? 'base-input-error' : ''}`}
            />
            {error && <span className="base-error-message">{error}</span>}
        </div>
    );
};

export default InputDate;
